"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnacceptableValueException = void 0;
const domain_exception_1 = require("./domain.exception");
/**
 * Should be thrown when some value does not comply with a requirement
 *
 * For example:
 * - Attempting to charge a customer using a gateway which doesn't exist
 * - Attempting to update a Stripe payment intent to a value less than 50
 * - Attempting to charge a customer a negative amount
 */
class UnacceptableValueException extends domain_exception_1.DomainException {
    constructor(message, data) {
        super(message, data);
    }
}
exports.UnacceptableValueException = UnacceptableValueException;
